<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
} from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";

import HeaderFragment from "./HeaderFragment.vue";
import WelcomePanel from "./WelcomePanel.vue"; //Tab 1
import AboutPanel from "./AboutPanel.vue"; //Tab 2
import InvestmentPanel from "./InvestmentPanel.vue"; //Tab 3
import ResultPanel from "./ResultPanel.vue"; //Tab 4
import NextPanel from "./NextPanel.vue"; //Tab 5
import DisclaimerPanel from "./DisclaimerPanel.vue"; //Tab 6
import EditableAssumptionsPanel from "./EditableAssumptionsPanel.vue"; //Tab 7

export default {
  name: "CalculatorScaffold",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    HeaderFragment,

    WelcomePanel,
    AboutPanel,
    InvestmentPanel,
    ResultPanel,
    NextPanel,
    DisclaimerPanel,
    EditableAssumptionsPanel,
  },

  setup() {},

  mounted() {
    document
      .querySelector("#mainNav")
      .addEventListener("keydown", this.handleAccessibleTabs, true);

    setTimeout(() => {
      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.activeTab],
        calculator_step: "Start",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.activeTab] + 
          ", calculator_step: Start"
        );
    }, 50);

    // Raw Javascript url params
    // let queryString = window.location.search;
    // let urlParams = new URLSearchParams(queryString);
    // console.log( urlParams.toString() );
    // console.log( urlParams.has("test") );
    // console.log( urlParams.get("test") );

    // Vue Router specific - may or may not work
    //console.log("testing", this.$route.query.test);
  },

  beforeUnmount() {
    document
      .querySelector("#mainNav")
      .removeEventListener("keydown", this.handleAccessibleTabs);
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "isLoading",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",

      "welcomeFieldsValid",
      "aboutFieldsValid",
      "investmentFieldsValid",
  ]),

  ...mapFields([
    "activeTabName",
  ]),

    currentYear() {
      return new Date().getFullYear();
    },
  },

  watch: {
    activeTabName(tabVal) {
      const tabNum = tabVal.substring(tabVal.length - 1);
      this.$store.commit("setActiveTab", tabNum);
    },

    activeTab(tabNum) {
      if (parseInt(tabNum) < 5) {
        if (!this.welcomeFieldsValid && tabNum > 1) {
          setTimeout(() => {
            this.$store.commit("setActiveTab", 1);
          }, 50);
        } else if (!this.aboutFieldsValid && tabNum > 2) {
          setTimeout(() => {
            this.$store.commit("setActiveTab", 2);
          }, 50);

        } else if (!this.investmentFieldsValid && tabNum > 3) {
          setTimeout(() => {
            this.$store.commit("setActiveTab", 3);
          }, 50);
        }
      }
    },

  },

  methods: {
    closeWindow() {
      window.close();
    },

    startOver() {
      // Reset values
      this.$store.commit("resetModeller");
      this.clickToTab(1);
    },

    topNavClickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[tabNum],
        calculator_step: "Navigation",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[tabNum] + 
          ", calculator_step: Navigation"
        );
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[tabNum],
        calculator_step: "Continue",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[tabNum] + 
          ", calculator_step: Continue"
        );
    },

    handleAccessibleTabs(event) {
      if (event.keyCode === 37 || event.keyCode === 39) {
        // Left or Right
        const currentTabPos = parseInt(
          event.srcElement.id.substring(event.srcElement.id.length - 1)
        );
        if (event.keyCode === 37) {
          // Left
          if (currentTabPos <= 2) { // Because there is no / we're not showing tab 1
            document.querySelector("#tab-tab6").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos - 1)).focus();
          }
        } else if (event.keyCode === 39) {
          // Right
          if (currentTabPos >= 5) {
            document.querySelector("#tab-tab2").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos + 1)).focus();
          }
        }
      } else if (event.keyCode === 13 || event.keyCode === 32) {
        document.querySelector("#" + event.srcElement.id).click();
      }
    },
  },

  data() {
    return {
      clientConfig,
      tabNames: [
        clientConfig.content.general.tabLabels.welcomeTab,
        clientConfig.content.general.tabLabels.aboutTab, 
        clientConfig.content.general.tabLabels.investmentsTab, 
        clientConfig.content.general.tabLabels.resultsTab,
        clientConfig.content.general.tabLabels.nextStepsTab,
      ]
    };
  },
};
</script>

<template>
  <MDBContainer 
    fluid 
    class="p-0 m-0 g-0"
    :class="isLoading && activeTab == 1 ? 'landing loading' : isLoading ? 'loading' : activeTab == 1 ? 'landing' : ''"
  >
    <MDBRow class="p-0 m-0">
      <MDBCol class="p-0 m-0">
              
        <MDBTabs v-model="activeTabName">
          <MDBRow 
            class="nav-bar" 
            tag="nav" 
            v-show="activeTab != 1"
          >
            
            <MDBCol md="2" class="d-flex justify-content-center nav-logo">
              <div class="logo" alt="Foresters Financial logo"></div>
            </MDBCol>

            <MDBCol class="nav-menu">
              <MDBTabNav
                pills
                tabsClasses="calc-nav"
                role="tablist"
                aria-label="Navigation Tabs"
                id="mainNav"
                v-show="activeTab != 1"
              >
                <!-- aboutTab -->
                <MDBTabItem
                  tabId="tab2"
                  :tabindex="activeTab == 2 ? 0 : -1"
                  role="tab"
                  aria-controls="tab2"
                  :aria-label="tabNames[1]"
                  :aria-selected="activeTab == 2 ? 'true' : 'false'"
                  @click="topNavClickToTab(2)"
                  class="one"
                  :class="lastActiveTab >= 3 ? 'completed' : ''"
                >
                  <span class="nav-link-text">
                    {{ tabNames[1] }}
                  </span>
                </MDBTabItem>

                <span class="step-divider"></span>

                <!-- investmentsTab -->
                <MDBTabItem
                  tabId="tab3"
                  :tabindex="activeTab == 3 ? 0 : -1"
                  role="tab"
                  aria-controls="tab3"
                  :aria-label="tabNames[2]"
                  :aria-selected="activeTab == 3 ? 'true' : 'false'"
                  @click="topNavClickToTab(3)"
                  class="two"
                  :class="lastActiveTab >= 4 ? 'completed' : ''"
                >
                  <span class="nav-link-text">
                    {{ tabNames[2] }}
                  </span>
                </MDBTabItem>

                <span class="step-divider"></span>
                
                <!-- resultsTab -->
                <MDBTabItem
                  tabId="tab4"
                  :tabindex="activeTab == 4 ? 0 : -1"
                  role="tab"
                  aria-controls="tab4"
                  :aria-label="tabNames[3]"
                  :aria-selected="activeTab == 4 ? 'true' : 'false'"
                  @click="topNavClickToTab(4)"
                  class="three"
                  :class="lastActiveTab >= 5 ? 'completed' : ''"
                >
                  <span class="nav-link-text">
                    {{ tabNames[3] }}
                  </span>
                </MDBTabItem>

                <span class="step-divider"></span>

                <!-- nextStepsTab -->
                <MDBTabItem
                  tabId="tab5"
                  :tabindex="activeTab == 4 ? 0 : -1"
                  role="tab"
                  aria-controls="tab5"
                  :aria-label="tabNames[4]"
                  :aria-selected="activeTab == 4 ? 'true' : 'false'"
                  @click="topNavClickToTab(5)"
                  class="four"
                  :class="lastActiveTab >= 6 ? 'completed' : ''"
                >
                  <span class="nav-link-text">
                    {{ tabNames[4] }}
                  </span>
                </MDBTabItem>
              </MDBTabNav>

            </MDBCol>
          </MDBRow>

          <MDBContainer xxl tag="main" class="p-0">
            <MDBTabContent>
              
              <MDBTabPane tabId="tab1" tabindex="0">
                <WelcomePanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab2" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.about.bannerHeading"
                />
                <AboutPanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab3" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.investment.bannerHeading"
                />
                <InvestmentPanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab4" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.results.bannerHeading"
                />
                <ResultPanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab5" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.whatsnext.bannerHeading"
                />
                <NextPanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab6" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.disclaimer.bannerHeading"
                />
                <DisclaimerPanel />
              </MDBTabPane>

              <MDBTabPane tabId="tab7" tabindex="0">
                <HeaderFragment
                  :title="clientConfig.content.assumptions.bannerHeading"
                />
                <EditableAssumptionsPanel />
              </MDBTabPane>

            </MDBTabContent>
          </MDBContainer>

          <footer class="main-footer">
            <MDBContainer xxl class="footer-text">
              <span class="d-block d-sm-inline">
                Built by Gallagher © {{ currentYear }}
              </span>

              <a
                href="javascript:;"
                @click="clickToTab(6)"
                class="internal-link disclaimer-link d-print-none"
              >Disclaimer</a>

              <a
                href="javascript:;"
                @click="clickToTab(7)"
                class="internal-link assumptions-link d-print-none"
              >Assumptions</a>
            </MDBContainer>
          </footer>

        </MDBTabs>

      </MDBCol>
    </MDBRow>
  </MDBContainer>

  <div 
    class="modal fade" 
    :class="isLoading ? 'show' : 'hide'" 
    :aria-hidden="isLoading ? 'false' : 'true'" 
    aria-modal="true" 
    aria-labelledby="loadingModalLabel" 
    role="dialog" 
    id="loadingModal" 
    tabindex="-1" 
    style="background-color: rgba(0, 0, 0, 0.3); padding-right: 17px;"
  >
    <div class="loadingContainer modal-dialog">
      <div class="rotating-dots">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
